export enum LegListFilterEnum {
  RouteGroups = 1,
  DepartureDate = 2,
  ReleaseDate = 3,
  Source = 4,
  LoadFactor = 5,
  Area = 6,
  PriceOverride = 7,
}
